export default {
  header: 'Menú',
  tabs: {
    menu: 'Menú',
    modifier_groups: 'Modificadores',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar el menú. Actualiza e inténtalo de nuevo',
  },
};
